import { DashboardContainerProps } from "../UI/Cards/Interfaces/DashboardContainer";
import { CAProjectListContainer } from "../UI/Section/CAProjectListContainer";
import { InvoiceSection } from "../UI/Section/InvoiceSection";
import { MiniProjectListContainer } from "../UI/Section/MiniProjectListContainer";
import { ProjectSection } from "../UI/Section/ProjectSection";
import { RFISection } from "../UI/Section/RFISection";
import { SubmittalSection } from "../UI/Section/SubmittalSection";
import { TaskSection } from "../UI/Section/TaskSection";

export const SECTION_REGISTRY = {
    project: {
        component: ProjectSection,
        label: "Projects",
        getProps: (props: DashboardContainerProps) => ({
            sorted_projects: props.sorted_projects,
            isNewCard: props.isNewCard,
            markAsSeen: props.markAsSeen
        }),
        defaultSize: 25,
    },
    task: {
        component: TaskSection,
        label: "Tasks",
        getProps: (props: DashboardContainerProps) => ({
            sorted_tasks: props.sorted_tasks,
            sorted_assignments: props.sorted_assignments,
            isNewCard: props.isNewCard,
            markAsSeen: props.markAsSeen,
        }),
        defaultSize: 25,
    },
    rfi: {
        component: RFISection,
        label: "RFIs",
        getProps: (props: DashboardContainerProps) => ({
            sorted_rfis: props.sorted_rfis,
            isNewCard: props.isNewCard,
            markAsSeen: props.markAsSeen,
        }),
        defaultSize: 25,
    },
    submittal: {
        component: SubmittalSection,
        label: "Submittals",
        getProps: (props: DashboardContainerProps) => ({
            sorted_submittals: props.sorted_submittals,
            isNewCard: props.isNewCard,
            markAsSeen: props.markAsSeen,
        }),
        defaultSize: 25,
    },
    invoice: {
        component: InvoiceSection,
        label: "Invoices",
        getProps: (props: DashboardContainerProps) => ({
            sorted_invoices: props.sorted_invoices,
            isNewCard: props.isNewCard,
            markAsSeen: props.markAsSeen,
        }),
        defaultSize: 25,
    },
    mini_project_list: {
        component: MiniProjectListContainer,
        label: "Project List",
        getProps: () => ({}), // No props needed; will get the project list from the component itself
        defaultSize: 50,
    },
    ca_project_list: {
        component: CAProjectListContainer,
        label: "Construction Admin Projects",
        getProps: () => ({}),
        defaultSize: 50,
    }
} as const;